import {Card, ListGroup} from "react-bootstrap";

const FeedCard = (props) => {
    const cardStyle = {
        backgroundColor:
            props.distance < 5 ? 'rgb(199,197,197)' :
                props.distance < 10 ? '#f3f3f3' :
                    props.distance < 20 ? '#bed363' :
                        (props.distance < 30) ? '#f0a500' :
                            (props.distance < 50) ? 'rgba(240,0,20,0.62)' :
                                (props.distance < 100) ? 'rgb(255,233,0)' :
                                'rgb(113,255,229)'
    };


    return (
        <Card>
            <Card.Header style={cardStyle} className="text-center">
                <i hidden={!props?.isKing} className="bi bi-trophy m-2"></i>{props?.email}
            </Card.Header>
            <Card.Body>
                <ListGroup className="list-group-flush">
                    <ListGroup.Item>{props?.activityName} </ListGroup.Item>
                    <ListGroup.Item>Distance [km]: {props?.distance} </ListGroup.Item>
                </ListGroup>
            </Card.Body>
        </Card>
    )
}

export default FeedCard;